import { Col, Text } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const StyledInput = styled.input`
  font-family: CeraPro;
  background-color: #fff;
  height: 54px;
  padding: 0 19px;
  width: ${(props) => props.wid || '442px'};
  border-radius: 15px;
  font-size: 22px;

  ${(props) =>
    props.password &&
    props.value.length &&
    `
    letter-spacing: 5px;
  `}

  @media (max-width: 1024px) {
    height: 37px;
    width: 100%;
    font-size: 18px;
    border-radius: 10px;
  }
`;

const DisabledContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => props.wid || '480px'};
  border-radius: 15px;
  opacity: 0.4;
  height: 100%;
  background-color: ${theme.GREY_40};
  cursor: unset;
`;

const AdminInput = (props) => {
  const { isMobile } = global;
  return (
    <Col noFlex pos="relative">
      {props.disabled && <DisabledContainer wid={props.wid} />}

      {props.title && (
        <Text marg="0 0 10px" size={isMobile ? '18px' : '20px'} col={theme.SECONDARY} med>
          {props.title}
        </Text>
      )}

      <StyledInput type={props.password && 'password'} {...props} ref={props.inputRef} />
    </Col>
  );
};

export default AdminInput;
